import { Component, Input } from '@angular/core';
import { FondsEvenementielConseil } from '@lib/models/generated/graphql';
import { FicheConseilService } from 'src/app/services/fiche-conseil.service';
import { FormConfigService } from 'src/app/services/form-config.service';
import { FieldFormControl } from 'src/fieldFormControl/FieldFormControl';

@Component({
  selector: 'app-fonds-evenementiel-checkbox',
  templateUrl: './fonds-evenementiel-checkbox.component.html',
  styleUrls: ['./fonds-evenementiel-checkbox.component.scss'],
})
export class FondsEvenementielCheckboxComponent {
  protected fondsEvenementiel: FondsEvenementielConseil;

  @Input({ required: true }) set fonds(value: FondsEvenementielConseil) {
    this.fondsEvenementiel = value;
    this.initData();
  }

  control: FieldFormControl<boolean, FondsEvenementielConseil>;

  constructor(protected ficheConseilService: FicheConseilService, protected formConfigService: FormConfigService) {}

  initData() {
    this.control = new FieldFormControl<boolean, FondsEvenementielConseil>({
      formConfigService: this.formConfigService,
      ficheConseilService: this.ficheConseilService,
      dataKey: 'fondsEvenementiels',
      ficheDataToFieldDataWrapper: (data: any) => data?.isSelected,
      fieldDataToFicheDataWrapper: (fieldData: boolean) => ({
        id: this.fondsEvenementiel.id,
        code: this.fondsEvenementiel.code,
        libelle: this.fondsEvenementiel.libelle,
        isSelected: fieldData,
      }),
      arrayItemSelector: (data: FondsEvenementielConseil) => {
        const fondsId = this.fondsEvenementiel?.id;
        const ficheFondsId = data?.id;
        return data && this.fondsEvenementiel && fondsId === ficheFondsId;
      },
      options: { nonNullable: true },
      defaultValue: false,
    });
  }
}
